// extracted by mini-css-extract-plugin
export default {"errorIconContainer":"errorIconContainer__1eGzR","errorIcon":"errorIcon__2h_C3","numberOfErrors":"numberOfErrors__1cS3t","errorMessageContainer":"errorMessageContainer__1LDUx"};